export const fabricCategories = [
  {
    id: 'japanese',
    name: 'أقمشة يابانية',
    description: 'أقمشة يابانية فاخرة بجودة استثنائية ونعومة لا مثيل لها، مستوردة مباشرة من أفضل المصانع اليابانية',
    image: 'https://public.readdy.ai/ai/img_res/6ebde2bedcbcd7e369489ac385698faf.jpg',
    country: 'يابانية',
  },
  {
    id: 'korean',
    name: 'أقمشة كورية',
    description: 'أقمشة كورية ممتازة بتصاميم عصرية وجودة عالية، تجمع بين الأناقة والمتانة لتناسب جميع الأذواق',
    image: 'https://readdy.ai/api/search-image?query=premium%20korean%20fabric%20collection%20modern%20elegant%20design%20soft%20beige%20cream%20colors%20high%20quality%20cotton%20silk%20blend%20materials%20displayed%20on%20pristine%20white%20background%20luxury%20textile%20photography%20studio%20shot&width=600&height=400&seq=cat-kr&orientation=landscape',
    country: 'كورية',
  },
  {
    id: 'indonesian',
    name: 'أقمشة إندونيسية',
    description: 'أقمشة إندونيسية راقية بنسيج متين وألوان ثابتة، مثالية للاستخدام اليومي والمناسبات الخاصة',
    image: 'https://readdy.ai/api/search-image?query=elegant%20indonesian%20fabric%20collection%20refined%20weave%20patterns%20warm%20beige%20ivory%20shades%20durable%20quality%20materials%20arranged%20on%20clean%20white%20background%20professional%20textile%20display%20luxury%20fabrics&width=600&height=400&seq=cat-id&orientation=landscape',
    country: 'إندونيسية',
  },
  {
    id: 'indian',
    name: 'أقمشة هندية',
    description: 'أقمشة هندية تقليدية بجودة عالية ونقوش أنيقة، تعكس التراث الهندي العريق بلمسة عصرية',
    image: 'https://readdy.ai/api/search-image?query=traditional%20indian%20fabric%20collection%20elegant%20beige%20gold%20tones%20subtle%20patterns%20premium%20quality%20silk%20cotton%20materials%20displayed%20beautifully%20on%20white%20background%20luxury%20textile%20photography%20heritage%20fabrics&width=600&height=400&seq=cat-in&orientation=landscape',
    country: 'هندية',
  },
  {
    id: 'chinese',
    name: 'أقمشة صينية',
    description: 'أقمشة صينية فاخرة بتصميم عصري وجودة ممتازة، تجمع بين الحرفية التقليدية والتقنيات الحديثة',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20chinese%20fabric%20collection%20modern%20elegant%20finish%20soft%20cream%20beige%20colors%20premium%20quality%20materials%20arranged%20on%20pristine%20white%20background%20high%20end%20textile%20display%20contemporary%20fabrics&width=600&height=400&seq=cat-cn&orientation=landscape',
    country: 'صينية',
  },
];